import React from 'react';
import './seccion-con-titulo.css';

const SeccionConTitulo = (props) => {
  const { titulo = '', children = null } = props;
  if (children === null) return false;
  return (
    <div className='element-common seccion'>
      {titulo === ''
        ? null
        : <h3 className='font-color-mbr-color-primario titulo-seccion alignment-content-detail mb-4'>{titulo}</h3>}
      {props.children}
    </div>
  );
};

// SeccionConTitulo.propTypes = {
//  titulo: PropTypes.string,
// };
export default SeccionConTitulo;
